export default __webpack_public_path__ + "static/media/firework-bg.1332b1fc.svg";